import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Collapse,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";
import classnames from "classnames";

// Import Images
import faqImg from "../../../assets/images/faq-img.png";
import FaqService from "../../../services/KangarooServices/FaqService";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";
import { Triangle } from "react-loader-spinner";

const Faqs = () => {
  document.title = "FAQs | Kangaroo Foundation";
  const [data, setdata] = useState([]);
  const navigate = useNavigate();
  const [isOpenDelete, setIsOpenDelete] = useState(false);
        const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState({}); // Track which dropdown is open
  const [isLoading, setIsLoading] = useState(false);
  const toggleDropdown = (id) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  
    const fetchdata = async () => {
      setIsLoading(true);
      try {
        const data = await FaqService.getList();
        setdata(data);
      } catch (error) {
        console.error("Error getting user:", error);
      } finally {
        setIsLoading(false);
      }
    };
    useEffect(() => {
    fetchdata();
  }, []);

  

  const [openFaqs, setOpenFaqs] = useState({});

  const toggleFaq = (categoryId, faqId) => {
    setOpenFaqs((prev) => ({
      ...prev,
      [categoryId]: prev[categoryId] === faqId ? null : faqId,
    }));
  };

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

    const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };
  

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await FaqService.deleteFaq(selectedDeleteItem.id);
        await fetchdata();
        toast.success("FAQ deleted successfully");
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Failed to delete FAQ"
        );
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card className="rounded-0 bg-success-subtle mx-n4 mt-n4 border-top">
                <div className="px-4">
                  <Row>
                    <Col xxl={5} className="align-self-center">
                      <div className="py-4">
                        <h4 className="display-6 coming-soon-text">
                          Frequently asked questions
                        </h4>
                        {/* <p className="text-success fs-16 mt-3">
                          If you cannot find answer to your question in our FAQ,
                          you can always contact us or email us. We will answer
                          you shortly!
                        </p> */}
                        <div className="hstack flex-wrap gap-2">
                          <button
                            type="button"
                            className="btn btn-success btn-label rounded-pill"
                            onClick={() => navigate("/faq/create")}
                          >
                            <i className="ri-add-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                            Create
                          </button>
                          {/* <button
                            type="button"
                            className="btn btn-info btn-label rounded-pill"
                          >
                            <i className="ri-twitter-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                          </button> */}
                        </div>
                      </div>
                    </Col>
                    <Col xxl={3} className="ms-auto d-none d-xxl-block">
                      <div className="mb-n5 pb-1 faq-img">
                        <img src={faqImg} alt="" className="img-fluid" />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card>
              {isLoading ? (
                <div className="my-3 d-flex justify-content-center align-items-center">
                  <Triangle height="100" width="100" color="#556ee6" />
                </div>
              ) : (
                <>
                  <Row className="justify-content-evenly mt-3">
                    {data.map((category) => (
                      <Col lg={4} key={category.id}>
                        <div className="mt-3">
                          <div className="d-flex align-items-center mb-2">
                            <div className="flex-shrink-0 me-1">
                              <i className="ri-question-line fs-24 align-bottom text-success me-1"></i>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="fs-17 mb-0 fw-bold">
                                {category.name}
                              </h5>
                            </div>
                          </div>

                          <div
                            className="accordion accordion-border-box"
                            id={`accordion-${category.id}`}
                          >
                            {category.faqs.map((faq) => (
                              <div
                                className="d-flex gap-2 align-items-start mb-2"
                                key={faq.id}
                              >
                                {/* Accordion */}
                                <div className="accordion-item w-100">
                                  <h2
                                    className="accordion-header"
                                    id={`heading-${faq.id}`}
                                  >
                                    <button
                                      className={classnames(
                                        "accordion-button",
                                        "fw-medium",
                                        {
                                          collapsed:
                                            openFaqs[category.id] !== faq.id,
                                        }
                                      )}
                                      type="button"
                                      onClick={() =>
                                        toggleFaq(category.id, faq.id)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      {faq.question}
                                    </button>
                                  </h2>

                                  <Collapse
                                    isOpen={openFaqs[category.id] === faq.id}
                                    className="accordion-collapse"
                                  >
                                    <div className="accordion-body"
                                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                                    />
                                  </Collapse>
                                </div>

                                {/* <Three-d></Three-d>ot dropdown */}
                                <Dropdown
                                  isOpen={dropdownOpen[faq.id] || false}
                                  toggle={() => toggleDropdown(faq.id)}
                                >
                                  <DropdownToggle
                                    tag="button"
                                    className="btn btn-light btn-sm p-1"
                                    aria-expanded={
                                      dropdownOpen[faq.id] || false
                                    }
                                  >
                                    <i className="ri-more-2-fill"></i>
                                  </DropdownToggle>
                                  <DropdownMenu end>
                                    <DropdownItem
                                      onClick={() =>
                                        navigate(`/faq/update/${faq.id}`)
                                      }
                                    >
                                      <i className="ri-edit-line me-2"></i> Edit
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => handleDeleteClick(faq)}
                                      className="text-danger"
                                    >
                                      <i className="ri-delete-bin-5-line me-2"></i>{" "}
                                      Delete
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </>
              )}
            </Col>
          </Row>
        </Container>
        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </div>
    </React.Fragment>
  );
};

export default Faqs;
